<ul class="stepper">
  @for (step of steps; track step) {
  <li
    (click)="selectStep(step)"
    [class.active]="step.active"
    [class.warning]="step.warning"
    [class.error]="step.error"
    [class.clickable]="step.clickable && !step.active"
    [ngStyle]="{ width: 100 / numberOfSteps + '%' }"
  >
    <button class="step-shape {{ shape }}" [ngStyle]="{ 'background-color': color }">
      <span
        id="step-icon"
        class="sif {{ step.state !== '' ? step.stepStateClass : step.icon }}"
      ></span>
    </button>
    <div class="step-title">{{ step.title }}</div>
  </li>
  }
</ul>
<ng-content></ng-content>
